import isNil from 'lodash-es/isNil';

export default (params: Record<string, unknown>): string => {
  const query = Object.entries(params || {})
    .filter(pair => !isNil(pair[1]))
    .map(pair => pair.map(v => encodeURIComponent(String(v))).join('='))
    .join('&');

  return query ? `?${query}` : query;
};
